import React, { Component } from 'react';
import { Col, Row, Button } from 'antd';
import logo from '../assets/imgs/qr.png';
import '../scss/landing.scss';
import consts, { PREFIX_FRONT_URL } from '../consts';
import QRCode from 'qrcode.react';
import { Translation } from 'react-i18next';
import bgLanding from '../assets/imgs/background_landing.png';

let checkLanguage = window.localStorage.getItem('LANG');

class BannerLandingComponent extends Component {
  componentWillReceiveProps() {
    checkLanguage = window.localStorage.getItem('LANG');
  }

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="landing__banner-layout landing__banner-layout-img">
            <div className="landing__banner-left">
              <div className="landing__banner-left-h2">
                {t('landing.text_1')}
              </div>
              <div className="landing__banner-left-h3">
                {t('landing.text_2')}
                .
              </div>
              <div className="landing__banner-left-row">
                <Button onClick={() => window.h.push(`${PREFIX_FRONT_URL}`)}>{t('landing.text_3')}</Button>
              </div>
            </div>
            {/* <Row>
              <Col span={12} className="d-flex self-center">

              </Col>

               <Col span={12} className="landing__banner-right  ">
                <div>
                   <img
                      src={require('../assets/imgs/image1.svg')}
                      alt="Anh"
                      className="slider-img"
                    />
                </div>
              </Col>
            </Row> */}
          </div>
        )}
      </Translation>
    );
  }
}

export default BannerLandingComponent;
